import { render } from "./QuotaUsageTab.vue?vue&type=template&id=0d512de4&scoped=true"
import script from "./QuotaUsageTab.vue?vue&type=script&lang=js"
export * from "./QuotaUsageTab.vue?vue&type=script&lang=js"

import "./QuotaUsageTab.vue?vue&type=style&index=0&id=0d512de4&lang=scss&scoped=true"

import exportComponent from "/mnt/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d512de4"]])

export default __exports__